export const formatDate = value => {
  if (!value) return '-'

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)

  return date.toLocaleString('es-CL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatCLP = value => {
  if (value === null || value === undefined || value === '') return '-'

  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return String(value)

  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0
  }).format(numeric)
}

export const formatQuantity = value => {
  if (value === null || value === undefined || value === '') return '-'

  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return String(value)
  if (Number.isInteger(numeric)) return String(numeric)

  return new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6
  }).format(numeric)
}
